import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=39c899e4&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=39c899e4&prod&lang=scss&scoped=true&"
import style1 from "./menu.vue?vue&type=style&index=1&id=39c899e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c899e4",
  null
  
)

export default component.exports